"use strict";
/**
 * @module Services.LogRetrieval
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var entries_fetch_request_1 = require("./entries-fetch-request");
/**
 * Serialiser for {@link EntriesFetchRequest}
 */
var EntriesFetchRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(EntriesFetchRequestSerialiserClass, _super);
    function EntriesFetchRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link EntriesFetchRequest} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link EntriesFetchRequest} that was read
     */
    EntriesFetchRequestSerialiserClass.prototype.read = function (bis) {
        var firstEntry = Codec.readInt64(bis);
        var entryCount = Codec.readInt64(bis);
        return new entries_fetch_request_1.EntriesFetchRequest(firstEntry, entryCount);
    };
    /**
     * Write a {@link EntriesFetchRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link EntriesFetchRequest} to be written
     */
    EntriesFetchRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeInt64(bos, value.firstEntry);
        Codec.writeInt64(bos, value.entryCount);
    };
    return EntriesFetchRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.EntriesFetchRequestSerialiserClass = EntriesFetchRequestSerialiserClass;
/**
 * The {@link EntriesFetchRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.EntriesFetchRequestSerialiser = new EntriesFetchRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/log-retrieval/entries-fetch-request-serialiser.js
// module id = 1320
// module chunks = 1